import { GetServerSideProps } from "next";

import { Product, SettingsResponse } from "@/api/generatedTypes";
import ProductApi from "@/api/ProductsApi";
import SettingsApi from "@/api/SettingsApi"
import { ProductPageComponent } from "@/pages-components/ProductPageComponent";

interface ProductPageProps {
  product: Product;
  slug: string;
  url: string;
  settings: SettingsResponse;
}

const ProductPage = ({ product, slug, url, settings }: ProductPageProps) => {
  return <ProductPageComponent product={product} slug={slug} url={url} settings={settings}/>;
};

export const getServerSideProps: GetServerSideProps<ProductPageProps> = async ({
  params,
  req,
}) => {
  const productSlug = params?.slug as string;

  const product = await ProductApi.find(productSlug);
  const settings = await SettingsApi.get();

  return {
    props: {
      product: product.data,
      slug: productSlug,
      url: req.url as string,
      settings: settings.data
    },
  };
};

export default ProductPage;
